import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { showNotification } from "store/slices/notificationSlice";

const unauthorizedCode = [400, 401];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const TOKEN_PAYLOAD_KEY = "Authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    store.dispatch(
      showNotification({
        message: "Error",
      })
    );
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: error.message,
    };

    // Handle network/timeout errors (no response object)
    if (!error.response) {
      if (error.code === "ECONNABORTED") {
        notificationParam.message = "Request Timeout";
        notificationParam.description = "Server tidak merespon, coba lagi nanti";
      } else {
        notificationParam.message = "Network Error";
        notificationParam.description = "Periksa koneksi internet Anda";
      }
      store.dispatch(showNotification(notificationParam));
      return Promise.reject(error);
    }

    // Remove token and redirect
    if (unauthorizedCode.includes(error.response.status)) {
      notificationParam.message = "Autentikasi Gagal";
      notificationParam.description = "Sesi login telah habis";
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem("outlet");
      localStorage.removeItem("username");
      localStorage.removeItem("boAccess");
      store.dispatch(signOutSuccess());
    }

    if (error.response.status === 403) {
      notificationParam.message =
        "Tidak memiliki izin akses terhadap halaman ini";
    }

    if (error.response.status === 422) {
      notificationParam.message = "Validasi Gagal";
    }

    if (error.response.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      notificationParam.message = "Time Out";
    }

    store.dispatch(showNotification(notificationParam));

    return Promise.reject(error);
  }
);

export default service;
